/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCycleIndexItemRequestBuilder, WithCycleIndexItemRequestBuilderNavigationMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/upcomingtransactions
 */
export interface UpcomingtransactionsRequestBuilder extends BaseRequestBuilder<UpcomingtransactionsRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.accounts.item.upcomingtransactions.item collection
     * @param cycleIndex The index of the cycle to retrieve transactions for (default is 0, which is the current cycle)
     * @returns {WithCycleIndexItemRequestBuilder}
     */
     byCycleIndex(cycleIndex: number) : WithCycleIndexItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const UpcomingtransactionsRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/upcomingtransactions";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const UpcomingtransactionsRequestBuilderNavigationMetadata: Record<Exclude<keyof UpcomingtransactionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCycleIndex: {
        navigationMetadata: WithCycleIndexItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["cycleIndex"],
    },
};
/* tslint:enable */
/* eslint-enable */
